import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Checkbox, IconButton, Typography, Box,
  CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/system'; // Import styled utility
import Pagination from '../../../Common/Pagination/pagination'; // Import your custom pagination component
import AddNewUser from './AddNewUser/AddNewUser'; // Import the AddNewUser component
import EditUser from './EditUser/EditUser';
import { useParams } from 'react-router-dom';
import AvatarImage from '../../../Navbar/AvatarImage';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { theme } from '../../../../theme';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { addUser, addUserImage, deleteUser, editUser, editUserImage, getAllUsers } from './userApi';
import { useSnackbar } from '../../../../Context/SnackbarContext';
import { Add } from '@mui/icons-material';
import { TableDescription, TableRowStyled } from '../../JobManagement/JobListing/JobListing.styles';
import { TableWrapper } from '../../CandidateManagement/CandidateContent/CandidateContent.styles';
import { useLoadingBackdrop } from '../../../../Context/LoadingBackdropContext';

// Styled components for Active and Inactive statuses
const ActiveStatus = styled('span')(({ theme }) => ({
  color: '#067647',
  border: '0.0694vw  solid #47CD89',
  background: '#ECFDF3',
  padding: '0.2778vw 0.97vw',
  borderRadius: '69.44vw ',
  fontWeight: 500,
}));

const InactiveStatus = styled('span')(({ theme }) => ({
  color: '#B54708',
  border: '0.0694vw  solid #FECDCA',
  background: '#FEF3F2',
  padding: '0.2778vw 0.83vw',
  borderRadius: '69.44vw ',
  fontWeight: 500,
}));
interface userData {
  UserNum: number;
  UserName: string;
  EmailID: string;
  UserID: string;
  DeleteItem: boolean;
  UpdatedBy: string;
  UserRole: string;
  UserStatus: string;
  ImageData: string;
  MIMEType: string
}
const User: React.FC = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
  const [totalCount, setTotalCount] = useState(0)
  const [selected, setSelected] = useState<string[]>([]); // Array to track selected users
  const [selectAll, setSelectAll] = useState(false); // State to track if the header checkbox is selected
  const [openAddUser, setOpenAddUser] = useState(false); // State to manage AddNewUser component visibility
  const [users, setUsers] = useState<userData[]>([]); // Default users list
  const [openEditUser, setOpenEditUser] = useState(false); // State for EditUser dialog
  const [currentUser, setCurrentUser] = useState<any>(null); // State for the user being edited
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // State for delete confirmation dialog
  const [userNumToDelete, setUserNumToDelete] = useState<number | null>(null); // Store the ID of the user to delete
  const { tenant } = useParams<{ tenant: string }>();
  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { show, hide } = useLoadingBackdrop();
  const columnsData = ['Username', 'User ID', 'Email Address', 'Role', 'Status', 'Updated By', 'Actions']

  const handleEditUser = (usernum: number) => {
    const userToEdit = users.find(user => user.UserNum === usernum);
    if (userToEdit) {
      setCurrentUser(userToEdit); // Set the current user to be edited
      setOpenEditUser(true); // Open the EditUser dialog
    }
  };

  const cancelDeleteUser = () => {
    setUserNumToDelete(null)
    setDeleteDialogOpen(false)
  }

  const confirmDeleteUser = async () => {
    setDeleteDialogOpen(false)
    const payLoad = {
      UserNum: userNumToDelete
    }
    const result = await deleteUser(tenant, payLoad)

    if (result) {
      setUsers((prevData) => prevData.filter((user) => user.UserNum !== userNumToDelete))
      showSnackbar("User deleted successfully.", "success")
    } else {
      showSnackbar("Failed to delete.Please try again.", "error")
    }
    setUserNumToDelete(null)
  }


  const fetchUsers = async (page: number, rowsPerPage: number) => {
    const payLoad = {
      page: page,
      pageSize: rowsPerPage
    }
    try {
      setLoading(true)
      const result = await getAllUsers(tenant, payLoad)
      if (result) {
        setUsers(result.data)
        setTotalCount(result.totalUsers)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  }

  useEffect(() => {
    fetchUsers(page, rowsPerPage)
  }, [page, rowsPerPage])

  const stripBase64 = (dataUrl: string) => {
    if (!dataUrl) return "";
    const parts = dataUrl.split(",");
    return parts.length === 2 ? parts[1] : dataUrl; // returns only base64 string
  };

  const handleUpdateUser = async (updatedUser: any) => {

    const existingUser = users.find(user => user.UserNum === updatedUser.usernum);

    const existingImage = existingUser?.ImageData || "";
    const updatedImage = stripBase64(updatedUser.photoURL || "");

    // Check for changes
    const hasChanges = existingUser && (
      existingUser.UserName !== updatedUser.username ||
      existingUser.EmailID !== updatedUser.email ||
      existingUser.UserRole !== updatedUser.role ||
      existingUser.UserStatus !== updatedUser.status ||
      existingImage !== updatedImage// Assuming this holds the URL of the user's photo
    );

    if (!hasChanges) {
      // No changes detected, just close the dialog
      setOpenEditUser(false);
      return; // Exit the function early
    }
    try {
      show()
      const payLoad = {
        "UserName": updatedUser.username,
        "EmailID": updatedUser.email,
        "RoleKey": updatedUser.role,
        "UserNum": updatedUser.usernum,
        "StatusKey": updatedUser.status
      }
      const result = await editUser(tenant, payLoad)

      if (updatedUser.photo) {
        const formData = new FormData()
        formData.append('UserNum', updatedUser.usernum)
        formData.append('Image', updatedUser.photo);
        await editUserImage(tenant, formData)
      }
      if (result) {
        setUsers(prevFilteredUsers => {
          return prevFilteredUsers.map(user => {
            if (user.UserNum === updatedUser.usernum) {
              const mimeType = updatedUser.photoURL?.match(/^data:(.*);base64/)?.[1] || '';

              return {
                ...user,
                UserName: updatedUser.username,
                EmailID: updatedUser.email,
                UserRole: updatedUser.role,
                UserStatus: updatedUser.status,
                // Update photoURL to refresh the image
                ImageData: updatedUser.photoURL?.split(',')[1] || "",  // base64
                MIMEType: mimeType

              };
            }
            return user;
          });
        });

        setOpenEditUser(false); // Close the dialog
        setCurrentUser(null);
        showSnackbar("User details updated successfully.", "success")
      } else {
        showSnackbar("Unable to update user details. Please try again later.", "error")
      }

    } catch (error) {
      console.log(error)
    }finally{
      hide()
    }
    // Clear current user
  };

  // Handle individual row selection
  const handleSelect = (username: string) => {
    const newSelected = selected.includes(username)
      ? selected.filter(name => name !== username)
      : [...selected, username];
    setSelected(newSelected);
  };

  // Handle header checkbox selection
  const handleSelectAll = () => {
    if (selectAll) {
      setSelected([]); // Clear all selections
    } else {
      const allUsernames = users.map(user => user.UserName);
      setSelected(allUsernames); // Select all users
    }
    setSelectAll(!selectAll);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(1); // Reset to the first page when rows per page changes
  };

  // Function to handle opening and closing of AddNewUser component
  const toggleAddUser = () => {
    setOpenAddUser(prev => !prev);
  };

  // Add new user from the AddNewUser dialog
  const handleAddUser = async (newUser: any) => {
    try {
      show()
      const payLoad = {
        "UserName": newUser.username,
        "EmailID": newUser.email,
        "UserRole": newUser.role,
        "UserID": newUser.userid,
        "UserStatus": newUser.status
      }
      const userNum = await addUser(tenant, payLoad)
      if (userNum) {
        if (newUser.photo) {
          const formData = new FormData()
          formData.append('UserNum', userNum.toString())
          formData.append('Image', newUser.photo);
          await addUserImage(tenant, formData)
        }
        const mimeType = newUser.photoURL?.match(/^data:(.*);base64/)?.[1] || '';
        setUsers((prevUsers) => [
          ...prevUsers.map((user) => ({
            ...user, // Ensures existing users retain their full properties
          })),
          {
            UserNum: userNum,
            UserName: newUser.username,
            EmailID: newUser.email,
            UserRole: newUser.role,
            UserStatus: newUser.status,
            UserID: newUser.userid, // Ensure UserID is included
            ImageData: newUser.photoURL?.split(',')[1] || "" || '', // Optionally include photoURL
            MIMEType: mimeType,
            DeleteItem: false, // or other default value
            UpdatedBy: "", // or other default value
          },
        ]);
        showSnackbar("User added successfully.", "success")
      } else {
        showSnackbar("Failed to add user. Please try again later.", "error")
      }
    } catch (error) {
      console.log(error)
    }finally{
      hide()
    }

  };



  const handleDeleteUser = (userNum: number) => {
    setUserNumToDelete(userNum)
    setDeleteDialogOpen(true)
  }

  return (
    <Box sx={{
      marginLeft: '2.3vw',
      marginRight: '1.3vw',
    }}>

      {/* Flex Container for Heading and Button */}
      <Box
        sx={{

          display: 'flex',
          flexDirection: 'column', // Align content in a column
          justifyContent: 'flex-start', // Ensure content aligns at the top
          minHeight: '100vh', // Ensure full height of the viewport
          boxSizing: 'border-box', // Include padding and border in width and height calculations
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '1.66vw' }}>
          <Box mb={2}>
            <Typography variant="h5">
              Manage Users
            </Typography>
            <Typography variant="subtitle1"  >
              Manage User Roles from One Place to Simplify Recruitment Operations
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            onClick={toggleAddUser}
            sx={{
              height:'2.7vw'
            }}
          >
            Add New User
          </Button>
        </Box>

        {/* Conditionally render the AddNewUser component */}
        {openAddUser && <AddNewUser open={openAddUser} onClose={toggleAddUser} onSubmit={handleAddUser} existingUserIds={users.map(user => user.UserID)} />}

        {/* Rendering EditUser component */}
        {openEditUser && currentUser && (
          <EditUser
            open={openEditUser}
            onClose={() => setOpenEditUser(false)}
            onSubmit={handleUpdateUser}
            userData={currentUser} // Pass the selected user data
          />
        )}

        <TableWrapper sx={{ tableLayout: 'auto', mb: '1.66vw' }}>
          <Box>
            <Table>
              <TableHead>
                <TableRow>
                  {columnsData.map((column) => (
                    <TableCell
                      key={column}
                      sx={{
                        color: theme.palette.text.secondary,
                        padding: '8px 12px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '13.89vw',
                        minWidth: '6.94vw',
                        textAlign: ['actions', 'status'].includes(column.toLowerCase()) ? 'center' : 'left'
                      }}
                    >
                      <Typography variant='caption' ml={column.toLowerCase() === 'username' ? '2vw' : '0vw'}>
                        {column.charAt(0).toUpperCase() + column.slice(1).replace(/_/g, ' ')}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columnsData.length} style={{ textAlign: 'center' }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                )
                  : users.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={columnsData.length} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        No User Data Available
                      </TableCell>
                    </TableRow>
                  ) :
                    (
                      users.map((user, index) => (
                        <TableRowStyled
                          key={index}
                          iseven={(index % 2 === 0).toString()}
                        >
                          <TableDescription

                          >
                            <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center',ml:'2vw' }}>
                              {user.ImageData ? (
                                <AvatarImage imageData={user.ImageData} Mimetype={user.MIMEType} height="40px" width="40px" />
                              )
                                :
                                (<AccountCircleOutlinedIcon sx={{ fontSize: '40px' }} />)
                              }
                              <Typography variant="body2" color="textPrimary">
                                {user.UserName}
                              </Typography>
                            </Box>
                          </TableDescription>
                          <TableDescription

                          >

                            {user.UserID}

                          </TableDescription>
                          <TableDescription

                          >

                            {user.EmailID}

                          </TableDescription>
                          <TableDescription

                          >

                            {user.UserRole}

                          </TableDescription>
                          <TableDescription
                            sx={{
                              paddingLeft: 0,
                              paddingRight: 0,
                              textAlign: 'center'
                            }}
                          >

                            {user.UserStatus === 'Active' ? (
                              <ActiveStatus>● {user.UserStatus}</ActiveStatus>
                            ) : (
                              <InactiveStatus>● {user.UserStatus}</InactiveStatus>
                            )}

                          </TableDescription>
                          <TableDescription

                          >

                            {user.UpdatedBy}

                          </TableDescription>
                          <TableDescription
                            sx={{
                              paddingLeft: 0,
                              paddingRight: 0,
                              textAlign: 'center'
                            }}>
                            <IconButton size="small" onClick={() => handleEditUser(user.UserNum)} sx={{ color: theme.palette.primary.main }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleDeleteUser(user.UserNum)} sx={{ color: theme.palette.primary.main }}>
                              <DeleteIcon />
                            </IconButton>
                          </TableDescription>
                        </TableRowStyled>
                      ))
                    )}
              </TableBody>
            </Table>
          </Box>
          {
            totalCount > 0 && (
              <Box p={1}>
                <Pagination
                  totalRows={totalCount}  // Adjusted for total rows
                  rowsPerPage={rowsPerPage}        // Current rows per page
                  currentPage={page}               // Current active page
                  onPageChange={handlePageChange}  // Callback for page change
                  onRowsPerPageChange={handleRowsPerPageChange} // Callback for rows per page change
                />
              </Box>
            )
          }

        </TableWrapper>
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={cancelDeleteUser}
      >
        <DialogTitle>
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText >
            Are you sure you want to delete this user? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDeleteUser} sx={{ color: theme.palette.text.secondary }}>
            Cancel
          </Button>
          <Button onClick={confirmDeleteUser}
            variant="contained"
            sx={{
              bgcolor: theme.palette.error.main,
              '&:hover': {
                bgcolor: theme.palette.error.dark,
              },
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );

};


export default User;
